module.exports = __webpack_public_path__ + "img/8f0926b4c1d73f5528b0736dd0b6de64.png";